export class MetaMaskNotInstalledError extends Error {
  constructor(message: string) {
    super(message);
  }
}
